module.exports = __webpack_public_path__ + "media/images/procedure_managements/not_results-b4e8aa58822ee3b7660e4f0fbb6a2da7.png";